<div [formGroup]="configFormGroup">
  <!-- <h2>Note Config</h2> -->
  <div dwRow>
    <div dwCol="6">
      <label>Note Type
        <span style="margin-left: 12px; color: gainsboro;">(Required)</span></label>
      <dw-select-lookup [lookupId]="lookupId" formControlName="NoteType"></dw-select-lookup>
    </div>
    <div dwCol="6">
      <label>Note Parent Field Name
        <span style="margin-left: 12px; color: gainsboro;">(Required)</span></label>
      <select formControlName="NoteKey" class="form-control">
        <option *ngFor="let attr of itemMetaData?.Attributes" [ngValue]="attr.AttributeName">
          {{ attr.Display }}
        </option>
      </select>
    </div>
  </div>
  <div dwRow>
    <div dwCol="4">
      <label class="compact-config-checkbox">Filter Notes By Type
        <input type="checkbox" formControlName="FilterListOnType" class="form-control">
      </label>
    </div>
    <div dwCol="4">
      <label class="compact-config-checkbox">Hide Auto-Delete
        <input type="checkbox" formControlName="HideAutoDelete" class="form-control">
      </label>
    </div>
    <div dwCol="4">
      <label>Read-Only Key&nbsp;
        <input type="text" formControlName="ReadOnlyKey">
      </label>
    </div>
  </div>
  <div dwRow>
    <div dwCol="6">
      <label>Delete Permission</label>
      <dw-security-permission-select formControlName="CanDeletePermissionMeaning">
      </dw-security-permission-select>
    </div>
    <div dwCol="6">
      <label>Edit Permission</label>
      <dw-security-permission-select formControlName="CanEditPermissionMeaning">
      </dw-security-permission-select>
    </div>
  </div>
  <div dwRow>
    <div dwCol="6">
      <label class="compact-config-checkbox">Save Record Id In AccessoryData Field
        <input type="checkbox" formControlName="SaveRecordId" class="form-control">
      </label>
    </div>
    <div dwCol="6">
      <label class="compact-config-checkbox">Show Note Source
        <input type="checkbox" formControlName="ShowNoteSource" class="form-control">
      </label>
    </div>
    <div dwCol="6">
      <label>Custom Height (Rows)&nbsp;
        <input type="number" formControlName="HeightInRows" min="1" max="8" value="1">
      </label>
      <div style="font-size: small;">This will assign 25px/row as the height of the input.</div>
    </div>
    <div dwCol="6">
      <label>Types to Exclude from showing source</label>
      <dw-multi-select-lookup [lookupId]="lookupId" formControlName="ExcludeNoteTypes" mapToArray="true">
      </dw-multi-select-lookup>
    </div>
  </div>
</div>